var _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDenso(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 60,
    id: "svg3193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3195"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-340.16784,-586.47325)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 357.54208,594.54575 c -0.2625,-0.885 -2.53,-5.4175 -2.53,-5.4175 l 23.535,0.01 c 7.8825,0 17.54,0.6975 22.32,6.14 3.8475,4.38 4.19,11.275 1.035,21.075 -8.145,25.3475 -25.9075,27.445 -44.4225,27.445 l -15.5475,0 15.61,-49.2525 z m 4.4875,42.5625 c 6.5625,-0.0326 12.2025,-1.095 15.625,-3.34 4.365,-2.8775 7.3825,-7.8775 10.405,-17.2625 2.68,-8.35 3.8225,-14.405 0.9475,-17.6675 -1.91,-2.1875 -6.505,-3.2425 -12.4125,-3.2425 -0.2675,0 -0.5325,0 -0.78,0.002 0,0 -2.515,-0.0474 -5.025,0.26 l -12.3975,38.7575 c 0,0 -0.66,2.4925 2.315,2.4925",
    id: "path256",
    style: {
      fill: "#e6232a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 425.78958,637.11077 24.8875,0.025 -2.1425,6.665 -41.4375,0 15.6075,-49.2525 c -0.26,-0.8875 -2.4825,-5.4275 -2.4825,-5.4275 l 44.05,0 -2.145,6.665 -26.1725,0 -5.185,16.1925 18.2675,0 -2.145,6.6825 -18.255,0 -5.045,15.8175 c 0,0 -0.6875,2.5675 2.1975,2.6325",
    id: "path260",
    style: {
      fill: "#e6232a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 468.42708,643.79827 12.525,-40.235 15.1275,40.235 11.7325,0 17.5725,-54.68 -9.4725,0 -11.9925,38.28 -0.185,-0.445 -14.0875,-37.835 -17.9475,0 c 0,0 2.225,4.54 2.485,5.4275 l -15.61,49.2525",
    id: "path264",
    style: {
      fill: "#e6232a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 571.67708,598.26075 c -2.1625,-0.99 -7.29,-3.22 -14.615,-3.305 -2.105,-0.016 -7.1825,0.58 -8.89,5.91 -1.445,4.4875 3.3925,6.9025 9.0025,9.69 7.185,3.58 15.3225,7.6425 12.1675,17.4575 -3.3975,10.5725 -14.4375,16.8675 -30.2775,16.63 -11.5425,-0.17 -17.1775,-2.3225 -17.1775,-2.3225 l 3.2225,-10.0675 2.335,1.335 c 2.305,1.315 8.4075,4.385 15.2375,4.385 2.285,0 5.5125,-0.415 8.11,-2.025 1.8575,-1.15 3.18,-3.035 3.9425,-5.41 1.5625,-4.8675 -3.41,-7.3875 -9.175,-10.3125 -7.0175,-3.555 -14.9775,-7.585 -11.895,-17.1325 1.255,-3.94 3.935,-7.335 7.73,-9.8275 4.95,-3.255 10.56,-4.9175 19.555,-4.975 6.3175,-0.0324 12.455,0.8025 15.03,1.4775 l 0.9575,0.27 -0.3575,1.1675 -1.8275,5.675 -0.78,2.4375",
    id: "path268",
    style: {
      fill: "#e6232a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 581.23958,616.67075 c 3.595,-11.18 8.49,-18.5075 15.43,-23.0625 5.7275,-3.76 12.72,-5.59 21.3825,-5.59 8.265,0 13.87,1.8025 17.1275,5.4975 4.0575,4.63 4.2825,11.98 0.69,23.155 -3.8975,12.1225 -11.885,28.2575 -36.12,28.2575 -8.5975,0 -14.395,-1.8425 -17.725,-5.6375 -4.0275,-4.5775 -4.2725,-11.7775 -0.785,-22.62 m 20.6775,21.515 c 3.425,0 6.34,-0.755 8.825,-2.465 5.6875,-3.8675 8.8825,-11.875 11.195,-19.05 2.515,-7.845 4.38,-15.6325 1.0025,-19.4875 -1.44,-1.63 -3.75,-2.4325 -7.0625,-2.4325 -12.005,0 -17.045,10.5325 -20.6975,21.92 -1.9725,6.1375 -4.185,14.7925 -0.5225,18.96 1.51,1.7175 3.8825,2.555 7.26,2.555",
    id: "path272",
    style: {
      fill: "#e6232a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenso);
export default __webpack_public_path__ + "static/media/denso.0a243a86e946e5d519ad1b1077074311.svg";
export { ForwardRef as ReactComponent };